import { render, staticRenderFns } from "./newSponsorEdition.vue?vue&type=template&id=072d64c2"
import script from "./newSponsorEdition.vue?vue&type=script&lang=js"
export * from "./newSponsorEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports